var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"自費","headers":_vm.selfburdenHeaders,"items":_vm.items},on:{"makenew":_vm.selfburdenCreate,"repair":_vm.selfburdenEdit,"copy":_vm.selfburdenCopy}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }